
const wrp = (props) => props.children;

export default wrp;